enum RenameDialogFields {
	FILENAME = 'filename'
}

export default RenameDialogFields;